import { render, staticRenderFns } from "./CreateEmployee.vue?vue&type=template&id=4a9a943e&scoped=true"
import script from "./CreateEmployee.vue?vue&type=script&lang=js"
export * from "./CreateEmployee.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployee.vue?vue&type=style&index=0&id=4a9a943e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a943e",
  null
  
)

export default component.exports